"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginRequestResponse = exports.ErrorResponse = exports.SuccessResponse = exports.ActivityResponse = exports.ActivityRequestError = exports.ActivityRequestTrigger = void 0;
var ActivityRequestTrigger;
(function (ActivityRequestTrigger) {
  ActivityRequestTrigger["Automatic"] = "automatic";
  ActivityRequestTrigger["Manual"] = "manual";
})(ActivityRequestTrigger = exports.ActivityRequestTrigger || (exports.ActivityRequestTrigger = {}));
var ActivityRequestError = /** @class */function () {
  function ActivityRequestError(code, message) {
    this.code = code;
    this.message = message;
  }
  return ActivityRequestError;
}();
exports.ActivityRequestError = ActivityRequestError;
var ActivityResponse = /** @class */function () {
  function ActivityResponse(request) {
    this.request = request;
  }
  return ActivityResponse;
}();
exports.ActivityResponse = ActivityResponse;
var SuccessResponse = /** @class */function (_super) {
  __extends(SuccessResponse, _super);
  function SuccessResponse(request, rawContent) {
    var _this = _super.call(this, request) || this;
    _this.request = request;
    _this.rawContent = rawContent;
    return _this;
  }
  return SuccessResponse;
}(ActivityResponse);
exports.SuccessResponse = SuccessResponse;
var ErrorResponse = /** @class */function (_super) {
  __extends(ErrorResponse, _super);
  function ErrorResponse(request, error) {
    var _this = _super.call(this, request) || this;
    _this.request = request;
    _this.error = error;
    return _this;
  }
  return ErrorResponse;
}(ActivityResponse);
exports.ErrorResponse = ErrorResponse;
var LoginRequestResponse = /** @class */function (_super) {
  __extends(LoginRequestResponse, _super);
  function LoginRequestResponse(request, auth) {
    var _this = _super.call(this, request) || this;
    _this.request = request;
    _this._auth = auth;
    for (var _i = 0, _a = _this._auth.buttons; _i < _a.length; _i++) {
      var button = _a[_i];
      if (button.type === "signin" && button.value !== undefined) {
        try {
          new URL(button.value);
          _this.signinButton = button;
          break;
        } catch (e) {
          // Ignore parsing error
        }
      }
    }
    return _this;
  }
  Object.defineProperty(LoginRequestResponse.prototype, "tokenExchangeResource", {
    get: function () {
      return this._auth.tokenExchangeResource;
    },
    enumerable: false,
    configurable: true
  });
  return LoginRequestResponse;
}(ActivityResponse);
exports.LoginRequestResponse = LoginRequestResponse;